<div class="apg-panel" [appScrollIntoView]="!loading" *ngIf="!timedOut">
  <div class="apg-loading" *ngIf="loading">
    <h4>
      Thanks for waiting while we load the questionnaire.<br />
      It should be ready in just a moment. <br />
      We appreciate your patience!
    </h4>
    <app-slideshow></app-slideshow>
  </div>
  <div class="wrapper" [class.hidden]="loading">
    <iframe *ngIf="magnumUrl" [src]="magnumUrl" id="magnumIframe"></iframe>
  </div>
</div>

<div class="apg-panel" *ngIf="timedOut">
  <app-site-content key="FullQuote.TimedOut"></app-site-content>

  <div class="summary__buttons" buttons>
    <ion-button (click)="retry()">Try Again</ion-button>
  </div>
</div>